import { Fragment, forwardRef } from "react";
import { Menu, Transition } from '@headlessui/react';
import { search } from "../../modules/order/actions/order.actions";
export function Dropdown(props: any) {
  return (
    <div className="text-right">
      <Menu as="div" className="relative inline-block text-left">
        {((props.primaryStatus === "OTHERS" && props.orderType !== "COURIER") || (props.primaryStatus !== "OTHERS")) ?
        <div>
          <Menu.Button className="inline-flex w-full justify-center rounded-md bg-white p-2 text-sm font-medium text-gray-900 hover:text-opacity-50 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path></svg>
          </Menu.Button>
        </div> : <></>}
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          {props.primaryStatus === "OTHERS" ? <CompletedOrderActions {...props} /> : <ActiveOrderActions {...props} />}
        </Transition>
      </Menu>
    </div>
  )
}

const ActiveOrderActions = forwardRef((props: any, ref: any) => {

  const toggleSearchDialog = async(orderNo: string) => {
    await search("ORDER", orderNo);
  }
  
  return (
    <Menu.Items ref={ref}
      className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
      <div className="px-1 py-1">
        {props.orderType !== 'COURIER' &&
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  props.setOpenModal(true);
                  props.setModalTitle('Validate')
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
                </svg>
                Validate order
              </button>
            )}
          </Menu.Item>}
        <Menu.Item>
          {({ active }) => (
            <button
              onClick={() => {
                props.setOpenModal(true);
                props.setModalTitle('Transfer')
              }}
              className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 489.8 489.8"
                xmlSpace="preserve"
                className="w-4 h-4 mr-2"
              >
                <g>
                  <g>
                    <path
                      id="XMLID_798_"
                      style={{ fill: "#94A4A4" }}
                      d="M480.7,454.75v-24.7c0-5.2-2.3-10.2-6.3-13.5c-22.3-18.3-46.3-30.5-51.2-32.9
c-0.6-0.3-0.9-0.8-0.9-1.4v-34.7c4.4-2.9,7.2-7.9,7.2-13.5v-36c0-17.9-14.5-32.4-32.4-32.4h-3.9h-3.9c-17.9,0-32.4,14.5-32.4,32.4
v36c0,5.6,2.9,10.6,7.2,13.5v34.7c0,0.6-0.3,1.2-0.9,1.4c-4.9,2.4-28.9,14.5-51.2,32.9c-4,3.3-6.3,8.3-6.3,13.5v24.7"
                    />
                    <path
                      style={{ fill: "#2C2F33" }}
                      d="M96.8,234.35c-5,0-9.1,4.1-9.1,9.1v36c0,42.9,34.9,77.8,77.8,77.8h114.4l-15,15
c-3.5,3.5-3.5,9.3,0,12.8c1.8,1.8,4.1,2.7,6.4,2.7s4.6-0.9,6.4-2.7l30.4-30.4c1.7-1.7,2.7-4,2.7-6.4s-1-4.7-2.7-6.4l-30.4-30.4
c-3.5-3.5-9.3-3.5-12.8,0s-3.5,9.3,0,12.8l15,15H165.5c-32.9,0-59.7-26.8-59.7-59.7v-36C105.8,238.35,101.8,234.35,96.8,234.35z"
                    />
                    <path
                      style={{ fill: "#2C2F33" }}
                      d="M211.7,147.05c1.8,1.8,4.1,2.7,6.4,2.7c2.3,0,4.6-0.9,6.4-2.7c3.5-3.5,3.5-9.3,0-12.8l-15-15h114.9
c32.9,0,59.7,26.8,59.7,59.7v36c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1v-36c0-42.9-34.9-77.8-77.8-77.8H209.6l15-15
c3.5-3.5,3.5-9.3,0-12.8s-9.3-3.5-12.8,0l-30.4,30.4c-1.7,1.7-2.7,4-2.7,6.4s1,4.7,2.7,6.4L211.7,147.05z"
                    />
                    <path
                      style={{ fill: "#2C2F33" }}
                      d="M9.3,233.25c5,0,9.1-4.1,9.1-9.1v-24.7c0-2.5,1.1-4.9,3-6.5c21.6-17.7,45-29.5,49.4-31.7
c3.6-1.8,6-5.5,6-9.6v-34.7c0-3-1.5-5.9-4-7.5c-2-1.3-3.2-3.6-3.2-6v-36c0-12.9,10.5-23.4,23.3-23.4h7.7
c12.9,0,23.3,10.5,23.3,23.4v36c0,2.4-1.2,4.6-3.2,6c-2.5,1.7-4,4.5-4,7.5v34.7c0,4,2.3,7.8,6,9.6c4.5,2.2,27.9,14,49.4,31.7
c1.9,1.6,3,3.9,3,6.5v24.7c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1v-24.7c0-8-3.5-15.4-9.7-20.5c-19.1-15.7-39.6-27.1-48.8-31.9
v-25.9c4.6-4.7,7.2-11,7.2-17.7v-36c0-22.9-18.6-41.5-41.5-41.5h-7.7c-22.9,0-41.5,18.6-41.5,41.5v36c0,6.7,2.6,13,7.2,17.7v25.9
c-9.2,4.8-29.7,16.2-48.8,31.9c-6.1,5-9.7,12.5-9.7,20.5v24.7C0.2,229.25,4.3,233.25,9.3,233.25z"
                    />
                    <path
                      style={{ fill: "#2C2F33" }}
                      d="M306.3,409.55c-6.1,5-9.7,12.5-9.7,20.5v24.7c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1v-24.7
c0-2.5,1.1-4.9,3-6.5c21.6-17.7,45-29.5,49.4-31.7c3.6-1.8,6-5.5,6-9.6v-34.7c0-3-1.5-5.9-4-7.5c-2-1.3-3.2-3.6-3.2-6v-36
c0-12.9,10.5-23.4,23.3-23.4h7.7c12.9,0,23.4,10.5,23.4,23.4v36c0,2.4-1.2,4.6-3.2,6c-2.5,1.7-4,4.5-4,7.5v34.7c0,4,2.3,7.8,6,9.6
c4.5,2.2,27.9,14,49.4,31.7c1.9,1.6,3,3.9,3,6.5v24.7c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1v-24.7c0-8-3.5-15.4-9.7-20.5
c-19.1-15.7-39.6-27.1-48.8-31.9v-25.9c4.6-4.7,7.2-11,7.2-17.7v-36c0-22.9-18.6-41.5-41.5-41.5h-7.7c-22.9,0-41.5,18.6-41.5,41.5
v36c0,6.7,2.6,13,7.2,17.7v25.9C345.9,382.45,325.5,393.85,306.3,409.55z"
                    />
                  </g>
                </g>
              </svg>
              Transfer order
            </button>
          )}
        </Menu.Item>
        {props.fleetId ?
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  props.setOpenModal(true);
                  props.setModalTitle('Unassign');
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg
                  className="w-4 h-4 mr-2"
                  viewBox="0 -64 640 640"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" />
                </svg>

                Unassign order
              </button>
            )}
          </Menu.Item>
          : <></>}
        {props.orderType === 'PICKUP' ?
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  props.setOpenModal(true);
                  props.setModalTitle('Convert to buy')
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg className="w-4 h-4 mr-2"
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <style
                      dangerouslySetInnerHTML={{
                        __html: ".cls-1{fill:#77acf1;}.cls-2{fill:#04009a;}"
                      }}
                    />
                  </defs>
                  <g data-name="18. Shopping" id="_18._Shopping">
                    <path
                      className="cls-1"
                      d="M18,10H17V9a1,1,0,0,0-2,0v1H14a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V12h1a1,1,0,0,0,0-2Z"
                    />
                    <path
                      className="cls-1"
                      d="M22.5,6.94,21.45,5.37A2,2,0,0,0,22,4V2a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V4a2,2,0,0,0,.55,1.37L9.5,6.94A3,3,0,0,0,9,8.61V17a1,1,0,0,0,2,0V8.61a1,1,0,0,1,.17-.56L12.54,6h6.92l1.37,2.05a1,1,0,0,1,.17.56V17a1,1,0,0,0,2,0V8.61A3,3,0,0,0,22.5,6.94ZM12,2h8V4H12Z"
                    />
                    <path
                      className="cls-2"
                      d="M28,23.82,28.87,18H31a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2H3.13L4,23.82.45,26.17a1,1,0,0,0,1.1,1.66L4.28,26l.36,2.55A4,4,0,0,0,8.6,32H23.4a4,4,0,0,0,4-3.43L27.72,26l2.73,1.81A.94.94,0,0,0,31,28a1,1,0,0,0,.55-1.83Zm-1.85-1.23L19.3,18h7.55ZM5.15,18H12.7L5.81,22.59ZM25.38,28.28a2,2,0,0,1-2,1.72H8.6a2,2,0,0,1-2-1.72l-.5-3.49L16,18.2l9.88,6.59Z"
                    />
                  </g>
                </svg>

                Convert to buy
              </button>
            )}
          </Menu.Item>
          : <></>}

        {props.orderType !== 'COURIER' ?
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  props.setOpenModal(true);
                  props.setModalTitle('Payments')
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg
                  fill="#000000"
                  width="800px"
                  height="800px"
                  viewBox="0 0 24 24"
                  id="mobile-payment-done"
                  data-name="Line Color"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 mr-2 text-indigo-400"
                >
                  <path
                    id="secondary"
                    d="M20,17H15V7h5a1,1,0,0,1,1,1v8A1,1,0,0,1,20,17Zm-5-6h6"
                    style={{
                      fill: "none",
                      stroke: "rgb(44, 169, 188)",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                    }}
                  />
                  <polyline
                    id="secondary-2"
                    data-name="secondary"
                    points="8 12 9.09 13.25 11 10.75"
                    style={{
                      fill: "none",
                      stroke: "rgb(44, 169, 188)",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                    }}
                  />
                  <path
                    id="primary"
                    d="M15,20V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H14A1,1,0,0,0,15,20ZM11,3H7l.5,2h3Z"
                    style={{
                      fill: "none",
                      stroke: "rgb(0, 0, 0)",
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                    }}
                  />
                </svg>

                View payments
              </button>
            )}
          </Menu.Item>
          : <></>}

        {props.tripInfo ?
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  toggleSearchDialog(props?.tripInfo?.orderNo)
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg
                  fill="#000000"
                  height="800px"
                  width="800px"
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  className="w-4 h-4 mr-2 text-indigo-400"
                >
                  <path
                    className="cls-1"
                    d="M11,10V7H8V5H9V2H6V5H7V7H4v3H3v3H6V10H5V8h5v2H9v3h3V10ZM5,12H4V11H5Zm6,0H10V11h1Z"
                  />
                </svg>
                View parent order
              </button>
            )}
          </Menu.Item>
          : <></>}

        {props.orderType === 'COURIER' && props.b2bOrderType === 2 && (props.deliveryStatus >= 80 && props.deliveryStatus <= 100) 
        && props?.subStatus !== 'RESCHEDULED' && !props?.isAlreadyRescheduled && 
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  props.setOpenModal(true);
                  props.setModalTitle('Reschedule')
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 338.784 338.784"
                  xmlSpace="preserve"
                  className="w-4 h-4 mr-2"
                >
                  <g>
                    <g>
                      <g>
                        <path d="M18.93,168.462C18.93,85.497,86.427,18,169.392,18c41.483,0,80.871,17.046,109.254,47.017h-7.688c-4.971,0-9,4.029-9,9 c0,4.971,4.029,9,9,9h30.522c4.971,0,9-4.029,9-9V43.494c0-4.971-4.029-9-9-9s-9,4.029-9,9v9.971 C260.649,19.401,216.217,0,169.392,0C76.502,0,0.93,75.572,0.93,168.462c0,40.967,14.882,80.454,41.903,111.188 c1.779,2.023,4.264,3.057,6.763,3.057c2.109,0,4.229-0.738,5.938-2.241c3.733-3.282,4.099-8.969,0.816-12.702 C32.22,240.318,18.93,205.052,18.93,168.462z" />
                        <path d="M327.121,109.168c-1.75-4.653-6.943-7.006-11.592-5.256c-4.652,1.75-7.006,6.939-5.256,11.592 c6.357,16.905,9.581,34.723,9.581,52.958c0,82.965-67.497,150.461-150.462,150.461c-24.007,0-47.843-5.792-69.014-16.738 l8.134-2.88c4.685-1.66,7.138-6.803,5.479-11.488c-1.659-4.687-6.808-7.138-11.488-5.479l-28.771,10.189 c-4.685,1.66-7.138,6.803-5.479,11.488l10.189,28.771c1.308,3.692,4.777,5.998,8.483,5.998c0.997,0,2.012-0.167,3.005-0.519 c4.685-1.66,7.138-6.803,5.479-11.488l-2.993-8.45c23.641,12.16,50.217,18.596,76.976,18.596 c92.891,0,168.462-75.571,168.462-168.461C337.854,148.056,334.243,128.106,327.121,109.168z" />
                        <path d="M169.392,56.371c-61.132,0-110.866,49.734-110.866,110.866c0,61.131,49.734,110.866,110.866,110.866 s110.866-49.734,110.866-110.866C280.259,106.105,230.524,56.371,169.392,56.371z M254.504,176.237h7.317 c-4.255,44.037-39.392,79.174-83.429,83.429v-7.317c0-4.971-4.029-9-9-9c-4.971,0-9,4.029-9,9v7.317 c-44.037-4.255-79.174-39.392-83.429-83.428h7.317c4.971,0,9-4.029,9-9s-4.029-9-9-9h-7.317 c4.255-44.037,39.392-79.174,83.429-83.429v7.317c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9v-7.317 c44.037,4.255,79.174,39.392,83.429,83.428h-7.317c-4.971,0-9,4.029-9,9C245.504,172.208,249.533,176.237,254.504,176.237z" />
                        <path d="M209.864,167.286h-6.303h-25.169v-35.939v-12.851c0-4.971-4.029-9-9-9c-4.971,0-9,4.029-9,9v57.79c0,4.971,4.029,9,9,9 h40.472c4.971,0,9-4.029,9-9S214.835,167.286,209.864,167.286z" />
                      </g>
                    </g>
                  </g>
                </svg>
                Reschedule order
              </button>
            )}
          </Menu.Item>}

      </div>
      <div className="px-1 py-1">
        <Menu.Item>
          {({ active }) => (
            <button
              onClick={() => {
                props.setOpenModal(true);
                props.setModalTitle('Cancel')
              }}
              className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
            >
              <svg className="w-4 h-4 mr-2 text-indigo-400" viewBox="0 0 200 200" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><title /><path d="M100,15a85,85,0,1,0,85,85A84.93,84.93,0,0,0,100,15Zm0,150a65,65,0,1,1,65-65A64.87,64.87,0,0,1,100,165Z" /><path d="M128.5,74a9.67,9.67,0,0,0-14,0L100,88.5l-14-14a9.9,9.9,0,0,0-14,14l14,14-14,14a9.9,9.9,0,0,0,14,14l14-14,14,14a9.9,9.9,0,0,0,14-14l-14-14,14-14A10.77,10.77,0,0,0,128.5,74Z" /></svg>
              Cancel order
            </button>
          )}
        </Menu.Item>
      </div>
    </Menu.Items>
  )
})

const CompletedOrderActions = forwardRef((props: any, ref: any) => {

  const toggleSearchDialog = async(orderNo: string) => {
    await search("ORDER", orderNo);
  }
  
  return (
    <Menu.Items ref={ref} className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
      <div className="px-1 py-1">
        {props.deliveryNo && !props.isCompensated ?
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  props.setOpenModal(true);
                  props.setModalTitle('Compensate');
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 19.928 19.928"
                  className="w-4 h-4 mr-2 text-indigo-400"
                  xmlSpace="preserve"
                >
                  <g>
                    <path
                      style={{
                        fill: "current",
                      }}
                      d="M11.273,3.18l-0.242-0.766c-0.096-0.305-0.228-0.603-0.393-0.884 c-0.545-0.926-1.18-1.328-1.425-1.352C9.122,0.373,9.136,1.12,9.701,2.081c0.538,0.916,1.165,1.318,1.417,1.351 C11.118,3.432,11.273,3.18,11.273,3.18z M13.731,2.081c0.564-0.961,0.578-1.708,0.488-1.903c-0.245,0.023-0.882,0.424-1.427,1.352 c-0.166,0.282-0.297,0.58-0.393,0.884L12.154,3.19l0.163,0.252C12.549,3.411,13.185,3.01,13.731,2.081z M11.381,3.927h2.02v2.818 h4.908V3.958H13.7c0.372-0.273,0.75-0.698,1.061-1.225c0.67-1.142,0.768-2.328,0.217-2.651C14.883,0.027,14.776,0,14.66,0 c-0.561,0-1.335,0.617-1.893,1.562c-0.186,0.319-0.324,0.639-0.42,0.945c-0.096-0.306-0.232-0.626-0.42-0.945 C11.372,0.617,10.595,0,10.033,0C9.92,0,9.812,0.027,9.716,0.082c-0.548,0.323-0.45,1.509,0.219,2.651 c0.311,0.527,0.691,0.952,1.062,1.225h-4.61v2.787h4.994V3.927z M12.974,2.705c0.087-0.278,0.208-0.55,0.359-0.81 c0.498-0.849,1.082-1.216,1.309-1.237c0.08,0.177,0.068,0.862-0.447,1.741c-0.502,0.852-1.084,1.218-1.295,1.246l-0.15-0.23 C12.75,3.415,12.974,2.705,12.974,2.705z M10.502,2.399c-0.516-0.879-0.53-1.564-0.446-1.741c0.224,0.021,0.807,0.389,1.306,1.237 c0.152,0.257,0.271,0.529,0.361,0.81l0.22,0.701l-0.142,0.23C11.569,3.607,10.996,3.238,10.502,2.399z M13.568,7.636v3.146 c0.364,0.184,0.465,0.516,0.465,0.516s0.072-0.034,0.072,1.479c0,1.514-0.324,1.568-0.537,1.616v0.824c0,0,2.462-0.796,3.928-2.65 c0.532-0.673,0.822-0.505,0.822-0.505l-0.01-4.426C18.308,7.636,13.568,7.636,13.568,7.636z M11.381,7.636H6.386v2.572 c1.209,0,3.428,0,4.994,0V7.636H11.381z M0.028,10.264h2.855v9.663H0.028V10.264z M18.054,13.379 c-0.113-0.044-0.23-0.061-0.349-0.041c-0.897,0.165-2.255,3.501-5.789,2.538c0,0-1.034-0.334-1.425-0.574 c-0.346-0.191-1.08-0.628-1.68-1.084h1.68h1.889c0,0,0.146,0.009,0.315-0.029c0.231-0.053,0.508-0.194,0.508-0.576 c0-0.66,0-1.647,0-1.647s-0.11-0.548-0.508-0.749c-0.091-0.046-0.194-0.075-0.315-0.075c-0.186,0-0.924,0-1.889,0 c-1.711,0-4.133,0-5.453,0c-0.581,0-0.949,0-0.949,0v7.026c0,0,5.602,1.758,7.578,1.758c0,0,4.939,0.22,8.234-3.624 C19.902,16.303,19.043,13.763,18.054,13.379z"
                    />
                  </g>
                </svg>

                Compensate order
              </button>
            )}
          </Menu.Item>
          : <></>}

        <Menu.Item>
          {({ active }) => (
            <button
              onClick={() => {
                props.setOpenModal(true);
                props.setModalTitle('Payments')
              }}
              className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
            >
              <svg
                fill="#000000"
                width="800px"
                height="800px"
                viewBox="0 0 24 24"
                id="mobile-payment-done"
                data-name="Line Color"
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 mr-2 text-indigo-400"
              >
                <path
                  id="secondary"
                  d="M20,17H15V7h5a1,1,0,0,1,1,1v8A1,1,0,0,1,20,17Zm-5-6h6"
                  style={{
                    fill: "none",
                    stroke: "rgb(44, 169, 188)",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                  }}
                />
                <polyline
                  id="secondary-2"
                  data-name="secondary"
                  points="8 12 9.09 13.25 11 10.75"
                  style={{
                    fill: "none",
                    stroke: "rgb(44, 169, 188)",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                  }}
                />
                <path
                  id="primary"
                  d="M15,20V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H14A1,1,0,0,0,15,20ZM11,3H7l.5,2h3Z"
                  style={{
                    fill: "none",
                    stroke: "rgb(0, 0, 0)",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                  }}
                />
              </svg>

              View payments
            </button>
          )}
        </Menu.Item>

        {props.tripInfo ?
          <Menu.Item>
            {({ active }) => (
              <button
                onClick={() => {
                  toggleSearchDialog(props?.tripInfo?.orderNo)
                  console.log(props.tripInfo)
                }}
                className={`${active ? 'bg-indigo-400 text-white' : 'text-gray-900'
                  } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
              >
                <svg
                  fill="#000000"
                  height="800px"
                  width="800px"
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  className="w-4 h-4 mr-2 text-indigo-400"
                >
                  <path
                    className="cls-1"
                    d="M11,10V7H8V5H9V2H6V5H7V7H4v3H3v3H6V10H5V8h5v2H9v3h3V10ZM5,12H4V11H5Zm6,0H10V11h1Z"
                  />
                </svg>
                View parent order
              </button>
            )}
          </Menu.Item>
          : <></>}
      </div>

    </Menu.Items>
  )
})
